import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { Organization } from 'src/app/core/models/organization.model';

@Injectable({
  providedIn: 'root'
})
export class OptionsStoreService {

  public addNewOrganization = new Subject<boolean>();
  public editOrganization = new Subject<Organization>();

  public statusChanged = new Subject<string>();

  public manageNumbers = new Subject<Organization>();
  public manageUploadNumbers = new Subject<Organization>();
  public manageDownloadNumbers = new Subject<Organization>();


  public manageAccounts = new Subject<Organization>();
  public manageDownloadAccounts = new Subject<Organization>();


  public manageLicenses = new Subject<Organization>();
  public manageUploadLicenses = new Subject<Organization>();
  public manageDownloadLicenses = new Subject<Organization>();

  public getOrganizations = new Subject<true>();
  public manageDownloadOrganizations = new Subject<string>();

  constructor() { }
}
